module.exports = __webpack_public_path__ + "img/teoloyucan.cfd1dd04.jpg";